/*
  TCG ENGRAVING DESIGNER (pop-out). Loaded by snippets/tcg-engraving-designer.liquid.
  Icons + designs come from metaobjects (#tcgx-data). Per-knife setup from product metafield engraving.config.
  Add to cart: knife line gets properties Engraving / Font / Icons (+ Logo file) and a hidden _engrave JSON
  used for "Edit engraving" in the cart and for rendering CJ artwork. The $15 fee line is synced by assets/tcg-engraving.js.
*/
(function () {
  'use strict';
  var dataEl = document.getElementById('tcgx-data');
  var tpl = document.getElementById('tcgx-tpl');
  if (!dataEl || !tpl || window.__tcgx) return;
  window.__tcgx = true;

  var D; try { D = JSON.parse(dataEl.textContent); } catch (e) { console.warn('tcgx data', e); return; }
  var C = D.cfg || {};
  var MAXC = C.max_chars || 22, ZONE_MM = C.mm || 80, ICONS_N = C.icons || 2, LOGO_OK = C.logo !== false;
  var MIN_CAP_MM = 2.6, COMFY_CAP_MM = 3.8, CAP = 0.7, FEE = D.fee || 15, FREE_AT = (D.freeAt || 199) * 100;

  var FONTS = {
    classic:   {label:'Classic',     group:'bold', css:"'Cinzel',serif",            weight:700, upper:true,  ls:'.12em', scale:1},
    modern:    {label:'Modern',      group:'bold', css:"'Montserrat',sans-serif",   weight:800, upper:true,  ls:'.1em',  scale:1},
    condensed: {label:'Condensed',   group:'bold', css:"'Bebas Neue',sans-serif",   weight:400, upper:true,  ls:'.08em', scale:1.25},
    slab:      {label:'Slab',        group:'bold', css:"'Roboto Slab',serif",       weight:700, upper:true,  ls:'.08em', scale:1},
    stencil:   {label:'Stencil',     group:'bold', css:"'Black Ops One',sans-serif",weight:400, upper:true,  ls:'.06em', scale:1},
    western:   {label:'Western',     group:'fun',  css:"'Rye',serif",               weight:400, upper:true,  ls:'.06em', scale:1},
    gothic:    {label:'Gothic',      group:'fun',  css:"'UnifrakturCook',serif",    weight:700, upper:false, ls:'.02em', scale:1.2},
    marker:    {label:'Marker',      group:'fun',  css:"'Permanent Marker',cursive",weight:400, upper:false, ls:'.03em', scale:1.1},
    boldscript:{label:'Bold Script', group:'fun',  css:"'Pacifico',cursive",        weight:400, upper:false, ls:'0',     scale:1.1}
  };

  /* Engraving variants: products with an option named "Engraving" (None / Text & icons / With logo)
     sell the engraving as a hidden variant linked to the CJ POD SKU. Without it we fall back to the $15 fee product. */
  var VARS = D.variants || [], OPTS = D.options || [], EPOS = OPTS.indexOf('Engraving');
  function baseVariant() {
    var f = entry && entry.closest('form'), i = f && f.querySelector('[name="id"]'), id = Number(i && i.value) || D.variantId;
    var v = VARS.find(function (w) { return w.id === id; }) || VARS[0];
    if (v && EPOS > -1 && v.options[EPOS] !== 'None') {
      v = VARS.find(function (w) { return w.options[EPOS] === 'None' && w.options.every(function (o, k) { return k === EPOS || o === v.options[k]; }); }) || v;
    }
    return v;
  }
  /* If the page loaded on an engraved variant (?variant=... from a cart link), switch the hidden picker back to None
     so the theme's own price and Add to cart button stay on the plain knife. */
  function resetEngravingPicker() {
    if (EPOS < 0) return;
    var sel = document.querySelector('select[name^="option-engraving-"]');
    if (sel && sel.value !== 'None') { sel.value = 'None'; sel.dispatchEvent(new Event('change', {bubbles: true})); return; }
    var r = document.querySelector('input[name^="option-engraving-"][value="None"]');
    if (r && !r.checked) { r.checked = true; r.dispatchEvent(new Event('change', {bubbles: true})); }
  }
  function engVariant(withLogo) {
    if (EPOS < 0) return null;
    var b = baseVariant(), want = withLogo ? 'With logo' : 'Text & icons';
    return VARS.find(function (v) {
      return v.options[EPOS] === want && v.options.every(function (o, k) { return k === EPOS || o === b.options[k]; });
    }) || null;
  }
  var ICONS = {};
  (D.icons || []).sort(function (a, b) { return a.sort - b.sort; }).forEach(function (i) { ICONS[i.h] = i; });
  var DESIGNS = (D.designs || []).filter(function (d) { return d.text && FONTS[d.font]; }).sort(function (a, b) { return a.sort - b.sort; });
  DESIGNS.push({h:'custom', badge:'Yours', text:'', short:'', font:'classic', L:null, R:null, aud:['all'], custom:true});

  /* ---------- mount ---------- */
  document.body.appendChild(tpl.content.cloneNode(true));
  var sheet = document.querySelector('.tcgx-sheet');
  function x(n) { return sheet.querySelector('[data-x="' + n + '"]'); }
  var entry = document.querySelector('[data-tcgx-entry]');

  x('knife').src = D.side || '';
  var zone = x('zone');
  zone.style.left = (C.left || 50) + '%'; zone.style.top = (C.top || 30) + '%';
  zone.style.width = (C.width || 30) + '%'; zone.style.height = (C.height || 12) + '%';
  if (C.etch) zone.style.setProperty('--etch', C.etch);
  var ETCH_DARK = (function (h) { h = String(h || '').trim().replace(/^#/, ''); if (h.length === 3) h = h.replace(/./g, '$&$&'); if (!/^[0-9a-f]{6}$/i.test(h)) return false; var n = parseInt(h, 16); return (0.2126 * ((n >> 16) & 255) + 0.7152 * ((n >> 8) & 255) + 0.0722 * (n & 255)) / 255 < 0.5; })(C.etch);
  zone.classList.toggle('dark', ETCH_DARK); sheet.classList.toggle('tcgx-etch-dark', ETCH_DARK);
  var kw = sheet.querySelector('.kwrap');
  if (C.mobile_zoom) kw.style.setProperty('--zoom', C.mobile_zoom + '%');
  if (C.mobile_shift != null) kw.style.setProperty('--shift', C.mobile_shift + '%');
  if (C.mobile_lift != null) kw.style.setProperty('--lift', C.mobile_lift + '%');
  x('phrase').maxLength = MAXC;

  var state = {preset:null, phrase:'', year:'', font:'classic', iconL:null, iconR:null, side: ICONS_N === 1 ? 'L' : 'both', logo:false, logoName:'', customYear:false, yearIn:'', textOn:true};
  var logoFile = null, FILTER = 'all', editKey = null, est = true;

  function clean(v) { return (v || '').replace(/[^A-Za-z0-9 .,'&#\-]/g, '').replace(/\s{2,}/g, ' ').slice(0, MAXC); }
  function fullText() { if (!state.textOn) return ''; var t = state.phrase.trim(); if (state.year) t = t ? t + ' · ' + state.year : state.year; return t; }
  function esc(t) { return String(t).replace(/&/g, '&amp;').replace(/</g, '&lt;'); }
  function money(c) { return '$' + (c / 100).toFixed(2); }
  function iconSvg(h) { return h && ICONS[h] ? ICONS[h].svg : ''; }
  function designText(d) { var t = (ICONS_N === 1 && d.short ? d.short : d.text) || ''; return t.replace('{NAME}', d.name || 'HARRISON'); }
  function designIcons(d) { return ICONS_N === 1 ? [d.L || d.R || null, null] : [d.L || null, d.R || null]; }

  /* ---------- designs ---------- */
  DESIGNS.forEach(function (d) {
    var b = document.createElement('button'); b.type = 'button'; b.className = 'preset'; b.dataset.h = d.h;
    b.dataset.aud = (d.aud || []).join('|');
    var di = designIcons(d), f = FONTS[d.font];
    var sample = d.custom ? 'Start blank' : designText(d) + (d.year ? ' · ' + d.year : '');
    b.innerHTML = '<span class="badge">' + esc(d.badge) + '</span><span class="line">' + iconSvg(di[0]) +
      '<span style="font-family:' + f.css.replace(/"/g, "'") + ';font-weight:' + f.weight + ';text-transform:' + (f.upper ? 'uppercase' : 'none') + '">' + esc(sample) + '</span>' + iconSvg(di[1]) + '</span>';
    b.addEventListener('click', function () {
      state.preset = d.h; state.customYear = false; x('yearIn').value = ''; state.textOn = true;
      if (d.custom) { state.phrase = ''; state.year = ''; state.iconL = null; state.iconR = null; }
      else {
        state.phrase = clean(designText(d)); state.year = d.year || ''; state.font = d.font;
        var i2 = designIcons(d); state.iconL = i2[0]; state.iconR = i2[1];
        if (d.logo && LOGO_OK) state.logo = true;
      }
      x('phrase').value = state.phrase; render(); refitOnFont(state.font);
      if (d.custom) x('phrase').focus();
    });
    x('presets').appendChild(b);
  });
  function applyFilter() {
    sheet.querySelectorAll('[data-x="who"] button').forEach(function (b) { b.classList.toggle('on', b.dataset.f === FILTER); });
    sheet.querySelectorAll('.preset').forEach(function (b) {
      var a = b.dataset.aud.split('|');
      var corpOnly = a.length === 1 && a[0] === 'Corporate';
      b.hidden = !(FILTER === 'all' || a.indexOf('all') > -1 || a.indexOf(FILTER) > -1) || (corpOnly && !LOGO_OK);
    });
    x('corpnote').style.display = FILTER === 'Corporate' ? 'block' : 'none';
  }
  sheet.querySelectorAll('[data-x="who"] button').forEach(function (b) { b.addEventListener('click', function () { FILTER = b.dataset.f; applyFilter(); }); });
  applyFilter();

  /* ---------- icons ---------- */
  function addIconBtn(h, label, svg) {
    var b = document.createElement('button'); b.type = 'button'; b.className = 'icn'; b.dataset.icon = h || ''; b.title = label; b.setAttribute('aria-label', label);
    b.innerHTML = h ? svg : '<small>None</small>';
    b.addEventListener('click', function () {
      if (ICONS_N === 1) { state.iconL = h; state.iconR = null; }
      else { if (state.side !== 'R') state.iconL = h; if (state.side !== 'L') state.iconR = h; }
      render();
    });
    x('icons').appendChild(b);
  }
  addIconBtn(null, 'No icon', '');
  Object.keys(ICONS).forEach(function (h) { addIconBtn(h, ICONS[h].name, ICONS[h].svg); });
  if (ICONS_N === 1) { x('sides').hidden = true; x('onehint').hidden = false; }
  sheet.querySelectorAll('[data-x="sides"] button').forEach(function (b) { b.addEventListener('click', function () { state.side = b.dataset.side; render(); }); });

  /* ---------- fonts ---------- */
  Object.keys(FONTS).forEach(function (k) {
    var f = FONTS[k], b = document.createElement('button');
    b.type = 'button'; b.className = 'fontopt'; b.dataset.font = k; b.setAttribute('aria-label', f.label + ' font');
    b.innerHTML = '<span class="fx" style="font-family:' + f.css.replace(/"/g, "'") + ';font-weight:' + f.weight + ';text-transform:' + (f.upper ? 'uppercase' : 'none') + ';font-size:' + (15 * Math.min(f.scale, 1.3)) + 'px">' + f.label + '</span>';
    b.addEventListener('click', function () { state.font = k; render(); refitOnFont(k); });
    x(f.group === 'bold' ? 'fontsBold' : 'fontsFun').appendChild(b);
  });

  /* ---------- tabs, text, years ---------- */
  sheet.querySelectorAll('.tab').forEach(function (t) {
    t.addEventListener('click', function () {
      sheet.querySelectorAll('.tab').forEach(function (z) { z.classList.toggle('on', z === t); });
      sheet.querySelectorAll('.pane').forEach(function (p) { p.classList.toggle('on', p.dataset.paneId === t.dataset.pane); });
    });
  });
  x('phrase').addEventListener('input', function () { state.phrase = clean(this.value); if (this.value !== state.phrase) this.value = state.phrase; render(); });
  sheet.querySelectorAll('[data-x="years"] .chip[data-year]').forEach(function (c) {
    c.addEventListener('click', function () { state.year = c.dataset.year; state.customYear = false; x('yearIn').value = ''; render(); });
  });
  function applyCustomYear() {
    var y = x('yearIn').value.replace(/\D/g, '').slice(0, 4);
    if (x('yearIn').value !== y) x('yearIn').value = y;
    if (!y) { if (state.customYear) { state.customYear = false; state.year = ''; } render(); return; }
    state.customYear = true; state.year = (est ? 'EST ' : '') + y; render();
  }
  x('yearIn').addEventListener('input', applyCustomYear);
  x('ycust').addEventListener('click', function (e) { if (e.target !== x('est')) x('yearIn').focus(); });
  x('est').addEventListener('click', function () {
    est = !est; this.classList.toggle('on', est); this.setAttribute('aria-pressed', est);
    if (x('yearIn').value) applyCustomYear(); else x('yearIn').focus();
  });

  /* ---------- logo ---------- */
  if (!LOGO_OK) { x('lock').hidden = false; x('logoOn').hidden = true; sheet.querySelector('.tab[data-pane="logo"]').classList.add('off'); }
  x('ltog').addEventListener('click', function () { if (!LOGO_OK) return; state.logo = !state.logo; if (!state.logo && !state.textOn) state.textOn = true; render(); });
  /* text on / off: logo-only engravings (text can only be switched off on knives that take a logo) */
  if (!LOGO_OK) x('ttog').hidden = true;
  x('ttog').addEventListener('click', function () {
    state.textOn = !state.textOn;
    if (!state.textOn && LOGO_OK) { state.logo = true; sheet.querySelector('.tab[data-pane="logo"]').click(); }
    render();
  });
  x('logoFile').addEventListener('change', function () {
    var f = this.files[0]; if (!f) return;
    logoFile = f; state.logoName = f.name; x('upName').textContent = f.name;
    state.logoUrl = null; loadLogo(f);
  });

  /* ---------- logo converter: one colour, in the browser ----------
     Removes the background, thresholds to laser / no laser, trims, checks size and detail,
     shows the exact result on the blade and saves that PNG (black on transparent) to the cart line. */
  var LC = {status:'', msg:'', out:null, thr:0, inv:false};
  var LC_MAX = 900;
  function lcSet(status, msg) {
    LC.status = status; LC.msg = msg;
    var m = x('lcMsg'); m.className = 'lc-msg ' + status; m.textContent = msg;
  }
  function loadLogo(file) {
    LC.out = null; LC.isSvg = /svg/i.test(file.type) || /\.svg$/i.test(file.name);
    x('lconv').hidden = false; lcSet('busy', 'Converting your logo…');
    var url = URL.createObjectURL(file), img = new Image();
    img.onload = function () { try { prepLogo(img); } catch (e) { console.warn(e); lcSet('error', 'We couldn’t read that file. Try a PNG or JPG.'); render(); } URL.revokeObjectURL(url); };
    img.onerror = function () { lcSet('error', 'We couldn’t read that file. Try a PNG or JPG.'); render(); };
    img.src = url;
  }
  function prepLogo(img) {
    var nw = img.naturalWidth || 600, nh = img.naturalHeight || 600;
    var s = LC.isSvg ? LC_MAX / Math.max(nw, nh) : Math.min(1, LC_MAX / Math.max(nw, nh));
    var w = Math.max(1, Math.round(nw * s)), h = Math.max(1, Math.round(nh * s)), n = w * h, i;
    var c = document.createElement('canvas'); c.width = w; c.height = h;
    var g = c.getContext('2d'); g.drawImage(img, 0, 0, w, h);
    var d = g.getImageData(0, 0, w, h).data, lum = new Float32Array(n), al = new Uint8Array(n), transp = 0;
    for (i = 0; i < n; i++) {
      al[i] = d[i * 4 + 3]; lum[i] = 0.299 * d[i * 4] + 0.587 * d[i * 4 + 1] + 0.114 * d[i * 4 + 2];
      if (al[i] < 128) transp++;
    }
    var bg;
    if (transp > n * 0.03) {
      /* transparent PNG / SVG: flatten onto whichever background contrasts with the artwork */
      var sum = 0, cnt = 0; for (i = 0; i < n; i++) if (al[i] >= 128) { sum += lum[i]; cnt++; }
      bg = (cnt ? sum / cnt : 0) > 150 ? 0 : 255;
    } else {
      /* solid background: median of the border pixels */
      var b = [], k;
      for (k = 0; k < w; k++) { b.push(lum[k], lum[(h - 1) * w + k]); }
      for (k = 0; k < h; k++) { b.push(lum[k * w], lum[k * w + w - 1]); }
      b.sort(function (p, q) { return p - q; }); bg = b[b.length >> 1];
    }
    for (i = 0; i < n; i++) { var a = al[i] / 255; lum[i] = lum[i] * a + bg * (1 - a); }
    /* Otsu threshold */
    var hist = new Array(256).fill(0); for (i = 0; i < n; i++) hist[Math.min(255, lum[i] | 0)]++;
    var tot = 0; for (i = 0; i < 256; i++) tot += i * hist[i];
    var sB = 0, wB = 0, best = 0, T = 128;
    for (i = 0; i < 256; i++) {
      wB += hist[i]; if (!wB) continue; var wF = n - wB; if (!wF) break;
      sB += i * hist[i]; var mB = sB / wB, mF = (tot - sB) / wF, v = wB * wF * (mB - mF) * (mB - mF);
      if (v > best) { best = v; T = i; }
    }
    /* shading / photo check: share of pixels sitting in the mid tones around the cut-off */
    var mid = 0; for (i = 0; i < n; i++) if (Math.abs(lum[i] - T) < 38) mid++;
    LC.w = w; LC.h = h; LC.lum = lum; LC.otsu = T; LC.bgLight = bg >= 128; LC.mid = mid / n;
    LC.small = !LC.isSvg && Math.min(nw, nh) < 120;
    LC.thr = 0; LC.inv = false; x('lcThr').value = 0; x('lcInv').classList.remove('on'); x('lcInv').setAttribute('aria-pressed', 'false');
    buildMask();
  }
  function buildMask() {
    if (!LC.lum) return;
    var w = LC.w, h = LC.h, n = w * h, lum = LC.lum, i, X, Y;
    var T = LC.otsu + (LC.bgLight ? LC.thr : -LC.thr);
    var ink = new Uint8Array(n), cnt = 0, x0 = w, y0 = h, x1 = -1, y1 = -1;
    for (i = 0; i < n; i++) {
      var on = LC.bgLight ? lum[i] < T : lum[i] > T; if (LC.inv) on = !on;
      if (on) { ink[i] = 1; cnt++; X = i % w; Y = (i / w) | 0; if (X < x0) x0 = X; if (X > x1) x1 = X; if (Y < y0) y0 = Y; if (Y > y1) y1 = Y; }
    }
    if (!cnt || cnt < n * 0.002 || cnt > n * 0.97) {
      LC.out = null; x('elogo').innerHTML = '';
      drawPrev(null, 0, 0);
      lcSet('error', 'We couldn’t find a clear logo in this image. Try Invert or move the Line weight slider.');
      render(); return;
    }
    var pad = Math.round(Math.max(x1 - x0, y1 - y0) * 0.03) + 2;
    x0 = Math.max(0, x0 - pad); y0 = Math.max(0, y0 - pad); x1 = Math.min(w - 1, x1 + pad); y1 = Math.min(h - 1, y1 + pad);
    var cw = x1 - x0 + 1, ch = y1 - y0 + 1, edges = 0, inkIn = 0;
    var out = document.createElement('canvas'); out.width = cw; out.height = ch;
    var og = out.getContext('2d'), od = og.createImageData(cw, ch);
    for (Y = y0; Y <= y1; Y++) for (X = x0; X <= x1; X++) {
      i = Y * w + X; if (!ink[i]) continue; inkIn++;
      var o = ((Y - y0) * cw + (X - x0)) * 4; od.data[o + 3] = 255;
      if (X === 0 || Y === 0 || X === w - 1 || Y === h - 1 || !ink[i - 1] || !ink[i + 1] || !ink[i - w] || !ink[i + w]) edges++;
    }
    og.putImageData(od, 0, 0);
    /* shading check: flat artwork puts nearly all solid ink pixels into a few tones, gradients spread them out */
    var bins = new Array(32).fill(0), solid = 0;
    for (Y = y0 + 1; Y < y1; Y++) for (X = x0 + 1; X < x1; X++) {
      i = Y * w + X; if (!ink[i] || !ink[i - 1] || !ink[i + 1] || !ink[i - w] || !ink[i + w]) continue;
      bins[Math.min(31, lum[i] >> 3)]++; solid++;
    }
    bins.sort(function (p, q) { return q - p; });
    LC.flat = solid > 200 ? (bins[0] + bins[1] + bins[2] + bins[3]) / solid : 1;
    /* average line thickness in real millimetres at the size it is engraved (logo height is fixed, width up to 4.6x) */
    var el = x('elogo'), hMM = (el.offsetHeight && zone.clientWidth) ? el.offsetHeight * ZONE_MM / zone.clientWidth : 9;
    var mmPerPx = Math.min(hMM / ch, hMM * 4.6 / cw);
    var strokePx = edges ? 2 * inkIn / edges : 99, strokeMM = strokePx * mmPerPx;
    LC.strokeMM = strokeMM;
    var gen = LC.gen = (LC.gen || 0) + 1; LC.out = null;
    out.toBlob(function (blob) {
      if (gen !== LC.gen) return;
      var base = (state.logoName || 'logo').replace(/\.[^.]+$/, '').replace(/[^A-Za-z0-9_-]+/g, '-').slice(0, 40);
      LC.out = new File([blob], base + '-engrave.png', {type: 'image/png'});
    }, 'image/png');
    /* blade preview in the etch colour */
    var tint = document.createElement('canvas'); tint.width = cw; tint.height = ch;
    var tg = tint.getContext('2d'); tg.drawImage(out, 0, 0); tg.globalCompositeOperation = 'source-in'; tg.fillStyle = C.etch || '#f4f4f1'; tg.fillRect(0, 0, cw, ch);
    x('elogo').innerHTML = '<img class="cv" src="' + tint.toDataURL('image/png') + '" alt="Your logo as it will be engraved">';
    drawPrev(tint, cw, ch);
    if (LC.small) lcSet('error', 'This file is too small to engrave sharply. Upload a larger version, at least 500px wide.');
    else if (!LC.isSvg && (LC.mid > 0.2 || LC.flat < 0.7)) lcSet('warn', 'This looks like a photo or has shading. Lasers etch one colour, so shading turns solid or disappears. Check the preview before adding.');
    else if (strokeMM < 0.25) lcSet('warn', 'Some lines are very fine and may not show at this size. Try moving Line weight towards Bold.');
    else lcSet('ok', 'Looks good. This is exactly how your logo will be engraved.');
    render();
  }
  function drawPrev(src, cw, ch) {
    var cv = x('lcCanvas'), W = 240, H = 120; cv.width = W * 2; cv.height = H * 2;
    var g = cv.getContext('2d'); g.setTransform(2, 0, 0, 2, 0, 0);
    var gr = g.createLinearGradient(0, 0, 0, H); if (ETCH_DARK) { gr.addColorStop(0, '#d8dadc'); gr.addColorStop(.5, '#edeff0'); gr.addColorStop(1, '#c3c6c9'); } else { gr.addColorStop(0, '#5a6069'); gr.addColorStop(.5, '#3c4149'); gr.addColorStop(1, '#4b5058'); }
    g.fillStyle = gr; g.fillRect(0, 0, W, H);
    if (!src) return;
    var sc = Math.min((W - 24) / cw, (H - 24) / ch);
    g.drawImage(src, (W - cw * sc) / 2, (H - ch * sc) / 2, cw * sc, ch * sc);
  }
  var lcRaf = 0;
  x('lcThr').addEventListener('input', function () { LC.thr = Number(this.value); cancelAnimationFrame(lcRaf); lcRaf = requestAnimationFrame(buildMask); });
  x('lcInv').addEventListener('click', function () { LC.inv = !LC.inv; this.classList.toggle('on', LC.inv); this.setAttribute('aria-pressed', String(LC.inv)); buildMask(); });

  /* ---------- fit (real mm) ---------- */
  function setLayout(two) {
    var e = x('etext'), ph = state.phrase.trim(), yr = state.year;
    if (!state.textOn) { e.textContent = ''; e.classList.remove('two'); return; }
    if (two && ph && yr) { e.innerHTML = esc(ph) + '<span class="yr">' + esc(yr) + '</span>'; e.classList.add('two'); }
    else { e.textContent = fullText() || 'Your Text'; e.classList.remove('two'); }
  }
  function shrink(maxH) {
    var e = x('etext'), size = zone.clientHeight * 0.42 * FONTS[state.font].scale * 2.2, g = 0;
    zone.style.fontSize = size + 'px';
    while ((zone.scrollWidth > zone.clientWidth || e.offsetHeight > maxH || (!state.textOn && x('elogo').offsetHeight > maxH)) && size > 3 && g < 220) { size -= 0.3; zone.style.fontSize = size + 'px'; g++; }
    return size;
  }
  function fit() {
    if (!zone.clientWidth) return;
    var mmPerPx = ZONE_MM / zone.clientWidth, sc = FONTS[state.font].scale;
    var minPx = MIN_CAP_MM / CAP / mmPerPx * sc, comfyPx = COMFY_CAP_MM / CAP / mmPerPx * sc;
    setLayout(false); var one = shrink(zone.clientHeight * 1.6);
    if (one < comfyPx && state.phrase.trim() && state.year) {
      setLayout(true); var s2 = shrink(zone.clientHeight * 2.1);
      if (s2 > one) one = s2; else { setLayout(false); shrink(zone.clientHeight * 1.6); }
    }
    state.tooSmall = !!fullText() && one < minPx;
    x('cnt').classList.toggle('bad', state.tooSmall);
    if (state.tooSmall) {
      var n = x('totNote'), cut = [];
      if (state.year) cut.push('the year');
      if ((state.iconL && !state.logo) || state.iconR) cut.push('an icon');
      n.classList.add('err');
      n.textContent = 'Too small to engrave cleanly (' + (one * CAP / sc * mmPerPx).toFixed(1) + 'mm letters). Shorten the text' + (cut.length ? ' or remove ' + cut.join(' / ') : '');
    }
  }
  /* re-fit once web fonts finish loading (first open can otherwise be mis-sized) */
  function refitOnFont(k) { var f = FONTS[k]; if (!f || !document.fonts || !document.fonts.load) return; try { document.fonts.load(f.weight + ' 1em ' + f.css).then(function () { if (state.font === k) { try { fit(); } catch (e) {} } }, function () {}); } catch (e) {} }
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { try { fit(); } catch (e) {} });

  /* ---------- pricing ---------- */
  function bothParts() { return state.logo && state.textOn; }
  function variantId() {
    var ev = engVariant(bothParts());
    if (ev) return ev.id;
    var f = entry && entry.closest('form');
    var i = f && f.querySelector('[name="id"]');
    return Number(i && i.value) || D.variantId;
  }
  function engFee() { var ev = engVariant(bothParts()), b = baseVariant(); return ev && b ? ev.price - b.price : (FEE + (bothParts() ? FEE : 0)) * 100; }
  function footer() {
    var n = x('totNote'); if (n.classList.contains('err')) return;
    var b = baseVariant(), base = b ? b.price : D.price, eng = engFee(), free = base >= FREE_AT;
    x('total').textContent = money(base + (free ? 0 : eng));
    n.innerHTML = 'Knife ' + money(base) + ' + engraving ' + (free ? '<s>' + money(eng) + '</s> <b style="color:var(--good)">FREE</b>' : money(eng));
  }

  /* ---------- render ---------- */
  function render() {
    sheet.querySelectorAll('.preset').forEach(function (b) { b.classList.toggle('on', b.dataset.h === state.preset); });
    sheet.querySelectorAll('.fontopt').forEach(function (b) { b.classList.toggle('on', b.dataset.font === state.font); });
    sheet.querySelectorAll('[data-x="years"] .chip[data-year]').forEach(function (b) { b.classList.toggle('on', !state.customYear && b.dataset.year === state.year); });
    x('ycust').classList.toggle('on', !!state.customYear);
    sheet.querySelectorAll('[data-x="sides"] button').forEach(function (b) { b.classList.toggle('on', b.dataset.side === state.side); });
    var effL = state.logo ? null : state.iconL;
    sheet.querySelectorAll('.icn').forEach(function (b) {
      var h = b.dataset.icon || null, l = h && h === effL, r = h && h === state.iconR;
      b.classList.toggle('on', h ? (l || r) : (!effL && !state.iconR));
      b.dataset.mark = (!h || effL === state.iconR || !(l || r)) ? '' : (l && r ? 'L R' : l ? 'L' : 'R');
    });
    x('cnt').textContent = state.phrase.length + '/' + MAXC;
    var F = FONTS[state.font], e = x('etext');
    e.style.fontFamily = F.css; e.style.fontWeight = F.weight; e.style.letterSpacing = F.ls; e.style.textTransform = F.upper ? 'uppercase' : 'none';
    x('eiconL').innerHTML = iconSvg(state.iconL); x('eiconR').innerHTML = iconSvg(state.iconR);
    x('eiconR').hidden = !state.iconR || !state.textOn;
    x('eiconL').hidden = !state.iconL || state.logo || !state.textOn;
    x('elogo').hidden = !state.logo;
    x('ltog').classList.toggle('on', state.logo); x('ltog').setAttribute('aria-checked', state.logo);
    x('ttog').classList.toggle('on', state.textOn); x('ttog').setAttribute('aria-checked', state.textOn); x('ttogLbl').textContent = state.textOn ? 'On' : 'Off';
    x('textrow').classList.toggle('notext', !state.textOn); x('etext').hidden = !state.textOn;
    x('upload').classList.toggle('off', !state.logo);
    x('totNote').classList.remove('err');
    footer();
    fit();
  }
  window.addEventListener('resize', function () { if (document.documentElement.classList.contains('tcgx-open')) fit(); });

  /* ---------- open / close ---------- */
  function open() {
    document.documentElement.classList.add('tcgx-open');
    if (!state.preset && !state.phrase && DESIGNS.length > 1) sheet.querySelector('.preset').click();
    render(); setTimeout(fit, 320);
  }
  function close() { document.documentElement.classList.remove('tcgx-open'); }
  document.querySelectorAll('[data-tcgx-open]').forEach(function (b) {
    b.addEventListener('click', function (e) { e.preventDefault(); e.stopPropagation(); open(); });
    b.addEventListener('keydown', function (e) { if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); open(); } });
  });
  document.querySelectorAll('.tcgx [data-tcgx-close]').forEach(function (b) { b.addEventListener('click', close); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });

  /* ---------- bulk quote ---------- */
  function openQuote() { x('quote').hidden = false; x('quoteDone').hidden = true; sheet.querySelector('#tcgx-quote-form').hidden = false; x('qDesign').value = fullText() || 'Logo only'; }
  x('openQuote').addEventListener('click', openQuote);
  x('closeQuote').addEventListener('click', function () { x('quote').hidden = true; });
  x('closeQuote2').addEventListener('click', function () { x('quote').hidden = true; });
  if (x('quotePosted') || /contact_posted=true/.test(location.search)) {
    open(); x('quote').hidden = false; sheet.querySelector('#tcgx-quote-form').hidden = true; x('quoteDone').hidden = false;
  }

  /* ---------- add to cart ---------- */
  function iconsLabel() {
    var l = state.logo || !state.textOn ? null : state.iconL, r = state.textOn ? state.iconR : null, out = [];
    if (l) out.push('Left: ' + ICONS[l].name); if (r) out.push('Right: ' + ICONS[r].name);
    return out.join(' · ');
  }
  function snap() { return {v:1, phrase:state.phrase, year:state.year, font:state.font, iconL:state.logo || !state.textOn ? null : state.iconL, iconR:state.textOn ? state.iconR : null, logo:state.logo, preset:state.preset, customYear:state.customYear, text:state.textOn}; }
  function showErr(msg) { var n = x('totNote'); n.textContent = msg; n.classList.add('err'); }

  x('add').addEventListener('click', async function () {
    if (!state.textOn && !state.logo) { showErr('Add text or a logo to engrave'); return; }
    if (state.textOn && !fullText()) { showErr('Add your engraving text first'); x('phrase').focus(); return; }
    if (state.tooSmall) { x('phrase').focus(); return; }
    if (state.logo && !logoFile && !(editKey && state.logoUrl)) { showErr('Upload your logo, or switch the logo off'); sheet.querySelector('.tab[data-pane="logo"]').click(); return; }
    if (state.logo && logoFile && (LC.status === 'error' || LC.status === 'busy' || !LC.out)) { showErr(LC.status === 'busy' || (!LC.out && LC.status !== 'error') ? 'Your logo is still converting, one moment' : 'Your logo can’t be engraved yet, see the Logo tab'); sheet.querySelector('.tab[data-pane="logo"]').click(); return; }
    var btn = this; btn.disabled = true; btn.textContent = 'Adding…';
    var form = entry && entry.closest('form');
    var qtyEl = form && form.querySelector('[name="quantity"]');
    var fd = new FormData();
    fd.append('id', variantId());
    fd.append('quantity', Math.max(1, Number(qtyEl && qtyEl.value) || 1));
    fd.append('properties[Engraving]', state.textOn ? fullText() : 'Logo only');
    if (state.textOn) fd.append('properties[Font]', FONTS[state.font].label);
    var il = iconsLabel(); if (il) fd.append('properties[Icons]', il);
    if (state.logo && logoFile) { fd.append('properties[Logo]', LC.out); fd.append('properties[_Logo original]', logoFile); }
    else if (state.logo && editKey && state.logoUrl) fd.append('properties[Logo]', state.logoUrl);
    fd.append('properties[_engrave]', JSON.stringify(snap()));
    var cc = document.querySelector('cart-component');
    try {
      close();
      if (editKey && cc && cc.change) { await cc.change(editKey, 0); editKey = null; }
      if (cc && cc.add) { await cc.add(fd); }
      else { var r = await fetch('/cart/add.js', {method:'POST', body:fd}); if (!r.ok) throw new Error('add failed'); location.href = '/cart'; return; }
      if (entry) {
        entry.classList.add('on');
        entry.querySelector('[data-tcgx-mini]').innerHTML = esc(state.textOn ? fullText() : 'Logo only') + '<span class="lg">Added to cart' + (state.logo ? ' · with logo' : '') + '</span>';
      }
    } catch (err) { console.warn(err); open(); showErr('Something went wrong, please try again'); }
    btn.disabled = false; btn.textContent = 'Add to cart';
  });

  /* ---------- edit from cart (?tcgx_edit=<line key>) ---------- */
  var qp = new URLSearchParams(location.search).get('tcgx_edit');
  if (qp) {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var it = cart.items.find(function (i) { return i.key === qp; });
      if (!it || !it.properties || !it.properties._engrave) { open(); return; }
      var s = JSON.parse(it.properties._engrave);
      state.phrase = clean(s.phrase); state.year = s.year || ''; state.font = FONTS[s.font] ? s.font : 'classic';
      state.iconL = s.iconL && ICONS[s.iconL] ? s.iconL : null; state.iconR = s.iconR && ICONS[s.iconR] ? s.iconR : null;
      state.logo = !!s.logo && LOGO_OK; state.preset = s.preset || null; state.customYear = !!s.customYear; state.textOn = s.text !== false || !state.logo;
      if (state.logo && it.properties.Logo) { state.logoUrl = String(it.properties.Logo); state.logoName = String(it.properties.Logo).split('/').pop().split('?')[0]; x('upName').textContent = state.logoName + ' (kept)'; x('elogo').innerHTML = '<img src="' + esc(state.logoUrl).replace(/"/g, '&quot;') + '" alt="">'; }
      if (state.customYear) x('yearIn').value = (state.year || '').replace(/\D/g, '');
      x('phrase').value = state.phrase; editKey = qp; x('add').textContent = 'Update cart';
      open();
    }).catch(function () { open(); });
  }

  resetEngravingPicker();
  render();
})();
